/* eslint-disable no-restricted-properties */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/* eslint-disable no-multi-assign */
/* eslint-disable no-undef */

import Store from '../configureStore';
import hashedCAProjectIdsArray from '../constants/hashedCAProjectIdsArray';
import { iframeCall } from './iframeHelper';

const { store } = Store;

const turnMsToSeconds = (millis) => {
  const ms = parseInt((millis % 1000), 10);
  const sec = parseInt((millis / 1000) % 60, 10);
  const min = Math.floor(millis / 60000);

  return {
    ms,
    sec,
    // eslint-disable-next-line
    complete: `${min}:${sec}`
  };
};

const trackEvent = async (event, data = {}) => {
  iframeCall(`track?data=${JSON.stringify({ event, data })}`);
};

const cleanHtml = (html) => (typeof html === 'string') && html
  .replace(/&#160;/g, ' ')
  .replace(/&#8217;/g, '’')
  .replace(/&#8203;/g, '')
  .replace(/&#13;/g, '')
  .replace(/&#8211;/g, '–')
  .replace(/&amp;/g, '&')
  .replace(/#/g, '')
  .replace(/&num;/g, '')
  .replace('<br />', '<br/>')
  .replace(/<br><\/br>/g, '<br/>')
  .replace(/\t/g, ' ')
  .replace(/<p><\/p>/g, '')
  .replace(/>\r?\n</g, '><')
  .replace(/\r?\n/g, '<br/>');

const isCanadaAppHandler = () => {
  const { projectId, apiGWPrefix } = store.getState().app;
  const hashedProjectId = sha256(projectId);

  // bp only web apps will have project_id in params
  const isExistingCaProjectId = hashedCAProjectIdsArray.includes(hashedProjectId);
  return apiGWPrefix === 'ca' || isExistingCaProjectId;
};

const sha256 = (string) => {
  function rightRotate(value, amount) {
    return (value >>> amount) | (value << (32 - amount));
  }

  const mathPow = Math.pow;
  const maxWord = mathPow(2, 32);
  const lengthProperty = 'length';
  let i; let
    j;
  let result = '';

  const words = [];
  const stringLength = string[lengthProperty] * 8;

  let hash = (sha256.h = sha256.h || []);
  const k = (sha256.k = sha256.k || []);
  const isComposite = {};

  let primeCounter = 0;
  for (let candidate = 2; primeCounter < 64; candidate++) {
    if (!isComposite[candidate]) {
      for (i = 0; i < 313; i += candidate) {
        isComposite[i] = candidate;
      }
      hash[primeCounter] = (mathPow(candidate, 0.5) * maxWord) | 0;
      k[primeCounter++] = (mathPow(candidate, 1 / 3) * maxWord) | 0;
    }
  }

  string += '\x80';
  while ((string[lengthProperty] % 64) - 56) string += '\x00';
  for (i = 0; i < string[lengthProperty]; i++) {
    j = string.charCodeAt(i);
    if (j >> 8) return;
    words[i >> 2] |= j << (((3 - i) % 4) * 8);
  }
  words[words[lengthProperty]] = (stringLength / maxWord) | 0;
  words[words[lengthProperty]] = stringLength;

  for (j = 0; j < words[lengthProperty];) {
    const w = words.slice(j, (j += 16));
    const oldHash = hash.slice(0);
    for (i = 0; i < 64; i++) {
      const w15 = w[i - 15];
      const w2 = w[i - 2];

      const a = hash[0];
      const e = hash[4];
      const temp1 = hash[7]
        + (rightRotate(e, 6) ^ rightRotate(e, 11) ^ rightRotate(e, 25))
        + ((e & hash[5]) ^ (~e & hash[6]))
        + k[i]
        + (w[i] = i < 16
          ? w[i]
          : (w[i - 16]
            + (rightRotate(w15, 7) ^ rightRotate(w15, 18) ^ (w15 >>> 3))
            + w[i - 7]
            + (rightRotate(w2, 17) ^ rightRotate(w2, 19) ^ (w2 >>> 10)))
          | 0);
      const temp2 = (rightRotate(a, 2) ^ rightRotate(a, 13) ^ rightRotate(a, 22))
        + ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]));

      hash = [(temp1 + temp2) | 0].concat(hash);
      hash[4] = (hash[4] + temp1) | 0;
    }

    for (i = 0; i < 8; i++) hash[i] = (hash[i] + oldHash[i]) | 0;
  }

  for (i = 0; i < 8; i++) {
    for (j = 3; j + 1; j--) {
      const b = (hash[i] >> (j * 8)) & 255;
      result += (b < 16 ? 0 : '') + b.toString(16);
    }
  }
  return result;
};

export {
  turnMsToSeconds,
  trackEvent,
  cleanHtml,
  sha256,
  isCanadaAppHandler,
  turnMsToSeconds as default
};
